import { parseTransformScript } from "../transform-script/core";
import type { TransformFunctionStatement } from "./types";

export function parseScript(code: string): TransformFunctionStatement[] {
  return parseTransformScript(code) as TransformFunctionStatement[];
}
